import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { ordersService } from '../../../shared/api/services/orders.service'
import type { OrderFilters } from '../types/order.types'

export const useOrders = () => {
    const [searchText, setSearchText] = useState('')
    const [statusFilter, setStatusFilter] = useState<string>('all')
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)

    const filters: OrderFilters = {
        page,
        per_page: pageSize,
        search: searchText || undefined,
        status: statusFilter !== 'all' ? statusFilter : undefined,
    }

    const { data: response, isLoading, isFetching, error, refetch } = useQuery({
        queryKey: ['orders', filters],
        queryFn: () => ordersService.getOrders(filters),
        placeholderData: (previousData) => previousData,
    })

    const orders = response?.data || []
    
    // Use real stats from API response
    const statistics = response?.statistics || {
        totalOrders: 0,
        totalRevenue: 0,
        deliveredOrders: 0
    }

    return {
        orders,
        totalOrders: response?.pagination.total || 0,
        searchText,
        setSearchText,
        statusFilter,
        setStatusFilter,
        page,
        setPage,
        pageSize,
        setPageSize,
        isLoading: isLoading || isFetching,
        statistics,
        refetch
    }
}
